const getAccountTypeByPlatform = (accountTypes, platform) => {
  if (platform?.label !== 'Tiktokshop') return accountTypes?.filter((account) => account?.label === 'Official');
  return accountTypes;
};

export default getAccountTypeByPlatform;
